import React, { FC } from 'react';
import { Stack } from '@mui/material';
import ProjectDpForm from '../ProjectDPForm';
import ProjectDPTabHeader from '../ProjectDPTabHeader';
import { ProjectTabDpProps } from './ProjectTabDPProps';

const ProjectTabDp: FC<ProjectTabDpProps> = ({ decisionPoints }) => {
  return (
    <Stack>
      <ProjectDPTabHeader decisionPoints={decisionPoints} />
      <ProjectDpForm decisionPoints={decisionPoints} />
    </Stack>
  );
};

export default ProjectTabDp;
